import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  WithStyles,
  withStyles,
  Divider,
  ButtonBase,
  Paper,
  MenuItem,
  Typography,
  FormControl,
  FormControlLabel,
  Checkbox,
  Radio,
  RadioGroup,
  Select,
  FormLabel,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  DialogContentText,
} from "@material-ui/core";
import * as React from "react";
import { Form, Formik } from "formik";
import imagePlacholder from "../assets/images/image-placeholder.png";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import {
  convertTextToTitleCase,
  isEmpty,
  POPUP_TRIGGERS,
  POPUP_TRIGGERS_ACTIONS,
} from "../constants/constants";
import RenderImagesDialog from "./RenderImagesDialog";
import { InspectionService } from "../services/InspectionService";
import AddQuickPicksDialog from "./AddQuickPicksDialog";
import { EventEmitter } from "../events/EventEmitter";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";

export const types = {
  DIALOG_INFO: "DIALOG_INFO",
  DIALOG_ACTION: "DIALOG_ACTION",
};
const styles = () =>
  createStyles({
    image: {
      width: 128,
      height: 128,
    },
    formControl: {
      marginTop: 20,
      minWidth: 120,
    },
    img: {
      "max-width": 120,
      "max-height": 120,
      overflow: "hidden",
    },
    listItem: {
      width: "100%",
      maxWidth: 360,
      backgroundColor: "white",
    },
  });
interface Props extends WithStyles<typeof styles> {
  dialogTitle: any;
  open: any;
  allCompanies: any;
  handleClose: any;
  defaultValue?: any;
  handleOnSubmit: any;
  editData: any;
}

class AddConfigurationDialog extends React.Component<Props> {
  state = {
    showPassword: false,
    hasError: false,
    type: "",
    openRenderImagesDialog: false,
    selectedImageItem: { base64: "", item: { filename: "", _id: "" } },
    indexSelected: -1,
    selectedCompany: {},
    company: {},
    openAddQuickPicksDialog: false,
    inspections: new Array<any>(),
    quickPick: {
      inspectionName: "",
      inspectionType: "",
      inspectionCategory: "",
    },
    deletingIndex: -1,
    editingIndex: -1,
    confirmDelete: false,
    quickPicks: new Array<any>(),
  };
  componentDidMount = async () => {
    const { editData } = this.props;
    if (editData && editData.name) {
      let base64 =
        editData.image && editData.image.base64
          ? Buffer.from(editData.image.base64).toString("base64")
          : "";
      let inspectionService: InspectionService = new InspectionService();
      let resp = await inspectionService.getInspectionsByCompanyId(
        editData.companyId
      );
      this.setState({
        company: this.getCompany(editData.companyId),
        inspections: resp && resp.success ? resp.inspections : [],
        quickPicks: editData.quickPicks
          ? editData.quickPicks
          : new Array<any>(),
        selectedImageItem: {
          base64: base64,
          item: {
            filename: editData.image.filename,
            _id: editData.image.imageId,
          },
        },
      });
    } else {
      this.setState({
        selectedImageItem: { base64: "", item: { filename: "", _id: "" } },
      });
    }
  };
  componentDidUpdate = async (prevProps: any, prevState: any) => {
    const { editData } = this.props;
    if (prevProps.editData.name !== this.props.editData.name) {
      if (editData && editData.name) {
        let base64 =
          editData.image && editData.image.base64
            ? Buffer.from(editData.image.base64).toString("base64")
            : "";
        let inspectionService: InspectionService = new InspectionService();
        let resp = await inspectionService.getInspectionsByCompanyId(
          editData.companyId
        );
        this.setState({
          company: this.getCompany(editData.companyId),
          inspections: resp && resp.success ? resp.inspections : [],
          quickPicks: editData.quickPicks
            ? editData.quickPicks
            : new Array<any>(),
          selectedImageItem: {
            base64: base64,
            item: {
              filename: editData.image.filename,
              _id: editData.image.imageId,
            },
          },
        });
      } else {
        this.setState({
          selectedImageItem: { base64: "", item: { filename: "", _id: "" } },
        });
      }
    }
  };
  handleOnImageSelected = (imageItem: any) => {
    this.setState({
      openRenderImagesDialog: false,
      selectedImageItem: imageItem,
    });
  };
  getCompany = (companyId: any) => {
    let companyies = this.props.allCompanies.filter((obj: any) => {
      return obj._id === companyId;
    });
    return companyies.length > 0 ? companyies[0] : null;
  };
  renderImagesDialog = () => {
    return (
      <RenderImagesDialog
        open={this.state.openRenderImagesDialog}
        companyData={this.getCompany(this.state.selectedCompany)}
        onClose={() => {
          this.setState({
            openRenderImagesDialog: false,
          });
        }}
        onSelectedItem={this.handleOnImageSelected}
        dialogTitle={"Choose Image"}
        images={[]}
      />
    );
  };
  handleOnOpenRenderImages = (selectedCompany: any) => {
    this.setState({
      openRenderImagesDialog: true,
      selectedCompany: selectedCompany,
    });
  };

  handleOnConfirmDelete = () => {
    let _quickPicks = this.state.quickPicks;
    if (this.state.deletingIndex > -1) {
      _quickPicks.splice(this.state.deletingIndex, 1);
      this.setState({
        quickPicks: _quickPicks,
        openAddQuickPicksDialog: false,
        confirmDelete: false,
      });
    }
  };

  renderConfirmDialog = () => {
    return (
      <Dialog
        open={this.state.confirmDelete}
        onClose={() => {
          this.setState({
            confirmDelete: false,
          });
        }}
        fullWidth={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Deleting Quick Pick`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {"Are you sure you want to delete this quick pick?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              this.setState({
                confirmDelete: false,
                quickPick: {
                  inspectionName: "",
                  inspectionType: "",
                  inspectionCategory: "",
                },
              });
            }}
          >
            Cancel
          </Button>
          <Button onClick={() => this.handleOnConfirmDelete()}>Yes</Button>
        </DialogActions>
      </Dialog>
    );
  };

  renderAddQuickPickDialog = () => {
    let company: any = this.state.company;
    return (
      <AddQuickPicksDialog
        dialogTitle={"Add Quick Pick"}
        company={company}
        inspections={this.state.inspections}
        open={this.state.openAddQuickPicksDialog}
        quickPickItem={this.state.quickPick}
        onClose={() => {
          this.setState({
            openAddQuickPicksDialog: false,
          });
        }}
        onSelectedOptions={(values: any) => {
          let _values = {
            inspectionName: values.inspectionName,
            inspectionType:
              values.inspectionType && values.inspectionType.value
                ? values.inspectionType.value
                : "",
            inspectionCategory:
              values.category && values.category.value
                ? values.category.value
                : "",
            equipment: values.equipment ? values.equipment : "",
          };
          let _quickPick = _values;
          let _quickPicks = this.state.quickPicks;
          let copyQuickPick: any = JSON.parse(JSON.stringify(_quickPick));
          if (this.state.editingIndex > -1) {
            _quickPicks.splice(this.state.editingIndex, 1, copyQuickPick);
          } else {
            let searchExist = this.state.quickPicks.filter((quickObj: any) => {
              return (
                quickObj.inspectionName === copyQuickPick.inspectionName &&
                quickObj.inspectionType === copyQuickPick.inspectionType &&
                quickObj.inspectionCategory === copyQuickPick.inspectionCategory
              );
            });
            if (searchExist.length === 0) {
              _quickPicks.push(copyQuickPick);
            } else {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                type: SNACKBAR_TYPE.ERROR,
                show: true,
                message: "The exact Inspection already exist.",
              });
            }
          }
          this.setState({
            openAddQuickPicksDialog: false,
            quickPicks: _quickPicks,
          });
        }}
      />
    );
  };

  render() {
    const {
      dialogTitle,
      open,
      handleClose,
      classes,
      editData,
      handleOnSubmit,
    } = this.props;

    return (
      <React.Fragment>
        <Dialog
          open={open}
          keepMounted={true}
          onClose={() => handleClose()}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          fullWidth={true}
          maxWidth={"md"}
        >
          <DialogTitle id="alert-dialog-slide-title">{dialogTitle}</DialogTitle>
          <Divider />
          <DialogContent>
            <Formik
              initialValues={
                editData && editData.name
                  ? editData
                  : {
                      name: "",
                      api: "",
                      companyId: "",
                      image: { base64: "", item: { filename: "", _id: "" } },
                      showAlert: false,
                      forcible: false,
                      frequency: "",
                      showOn: { label: "", value: "" },
                      okButton: "",
                      successAction: { label: "", value: "" },
                      cancelButton: "",
                      cancelAction: { label: "", value: "" },
                      pageTitle: "",
                      popupContent: "",
                      quickPicks: new Array<any>(),
                    }
              }
              enableReinitialize={true}
              onSubmit={() => {}}
            >
              {({
                values,
                handleChange,
                handleBlur,
                setFieldValue,
                setFieldError,
                isValid,
                handleReset,
              }) => (
                <Form>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      <TextField
                        select
                        id={"Company Name"}
                        value={
                          values.companyId ? values.companyId : values.name
                        }
                        onChange={(event) => {
                          this.setState(
                            {
                              selectedCompany: event.target.value,
                            },
                            () => {
                              setFieldValue("name", event.target.value);
                            }
                          );
                        }}
                        onBlur={handleBlur}
                        name={"name"}
                        label={"Company Name"}
                        fullWidth
                        helperText={
                          "To see the company here please add it on companies."
                        }
                      >
                        {this.props.allCompanies.map((option: any) => (
                          <MenuItem key={option._id} value={option._id}>
                            {option.name}
                          </MenuItem>
                        ))}
                      </TextField>
                      {values.name && (
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                          }}
                        >
                          <ButtonBase className={classes.image}>
                            {this.state.selectedImageItem.base64 &&
                            !isEmpty(this.state.selectedImageItem.base64) ? (
                              <img
                                className={classes.img}
                                alt="complex"
                                src={`data:image/jpeg;base64,${this.state.selectedImageItem.base64}`}
                              />
                            ) : (
                              <img
                                className={classes.img}
                                alt="complex"
                                src={imagePlacholder}
                              />
                            )}
                          </ButtonBase>
                          <Paper
                            elevation={3}
                            style={{
                              width: "50%",
                              height: 50,
                              margin: 10,
                              alignSelf: "center",
                              justifyContent: "center",
                              alignItems: "center",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Button
                              size="small"
                              style={{
                                backgroundColor: "white",
                                color: "grey",
                                borderColor: "grey",
                                borderWidth: 1,
                                height: 48,
                                width: "100%",
                              }}
                              onClick={() =>
                                this.handleOnOpenRenderImages(
                                  values.companyId
                                    ? values.companyId
                                    : values.name
                                )
                              }
                              startIcon={<CloudUploadIcon />}
                            >
                              Upload
                            </Button>
                          </Paper>
                        </div>
                      )}
                      <TextField
                        id={"api"}
                        value={values.api}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        name={"api"}
                        label={"Company API"}
                        fullWidth
                      />
                      <Paper
                        style={{
                          display: "flex",
                          margin: 20,
                          padding: 20,
                          width: "100%",
                          flexDirection: "column",
                        }}
                      >
                        <Typography>{"Notifications"}</Typography>
                        <Divider style={{ marginTop: 20 }} />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="showAlert"
                              checked={values.showAlert}
                            />
                          }
                          label="Show alert"
                          value={values.showAlert}
                          onChange={handleChange}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="forcible"
                              checked={values.forcible}
                            />
                          }
                          label="Forcible"
                          value={values.forcible}
                          onChange={handleChange}
                        />
                        <FormControl
                          component="fieldset"
                          style={{ marginTop: 20 }}
                        >
                          <FormLabel component="legend">
                            {"Popup Frequency"}
                          </FormLabel>
                          <RadioGroup
                            aria-label="frequency"
                            name="frequency"
                            value={values.frequency}
                            onChange={handleChange}
                            style={{
                              flexDirection: "row",
                              display: "flex",
                            }}
                          >
                            <FormControlLabel
                              value="onceOff"
                              control={<Radio />}
                              label="Once off"
                            />
                            <FormControlLabel
                              value="everytime"
                              control={<Radio />}
                              label="Every Time"
                            />
                          </RadioGroup>
                        </FormControl>
                        <FormControl
                          variant="outlined"
                          style={{ flex: 0.3 }}
                          className={classes.formControl}
                        >
                          <InputLabel htmlFor="outlined-age-native-simple">
                            Show On
                          </InputLabel>
                          <Select
                            value={
                              values.showOn && values.showOn.value
                                ? values.showOn.value
                                : ""
                            }
                            onChange={(event: any) => {
                              if (event && event.target && event.target.value) {
                                let filtered = POPUP_TRIGGERS.filter(
                                  (x: any) => {
                                    return x.value === event.target.value;
                                  }
                                );
                                setFieldValue("showOn", filtered[0]);
                              }
                            }}
                            label="Show On"
                            inputProps={{
                              name: "showOn",
                              id: "outlined-age-native-simple",
                            }}
                          >
                            {POPUP_TRIGGERS.map((obj: any, index: any) => {
                              return (
                                <MenuItem
                                  key={`machin-item-${index}`}
                                  value={obj.value}
                                >
                                  {obj.label}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                        <TextField
                          id={"pageTitle"}
                          value={values.pageTitle}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name={"pageTitle"}
                          label={"Page Title"}
                          variant={"outlined"}
                          fullWidth
                          style={{ marginTop: 20 }}
                        />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            marginTop: 20,
                            justifyContent: "space-between",
                          }}
                        >
                          <TextField
                            id={"cancelButton"}
                            value={values.cancelButton}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name={"cancelButton"}
                            label={"Cancel Title"}
                            variant={"outlined"}
                            style={{ width: "40%" }}
                          />
                          <TextField
                            id={"okButton"}
                            value={values.okButton}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name={"okButton"}
                            label={"Success Title"}
                            variant={"outlined"}
                            style={{ width: "40%" }}
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            marginTop: 20,
                            justifyContent: "space-between",
                          }}
                        >
                          <FormControl
                            variant="outlined"
                            style={{ width: "40%" }}
                          >
                            <InputLabel htmlFor="outlined-age-native-simple">
                              Cancel Action
                            </InputLabel>
                            <Select
                              value={
                                values.cancelAction && values.cancelAction.value
                                  ? values.cancelAction.value
                                  : ""
                              }
                              onChange={(event: any) => {
                                if (
                                  event &&
                                  event.target &&
                                  event.target.value
                                ) {
                                  let filtered = POPUP_TRIGGERS_ACTIONS.filter(
                                    (x: any) => {
                                      return x.value === event.target.value;
                                    }
                                  );
                                  setFieldValue("cancelAction", filtered[0]);
                                }
                              }}
                              label="Cancel Action"
                              inputProps={{
                                name: "cancelAction",
                                id: "outlined-age-native-simple",
                              }}
                            >
                              {POPUP_TRIGGERS_ACTIONS.map(
                                (obj: any, index: any) => {
                                  return (
                                    <MenuItem
                                      key={`machin-item-${index}`}
                                      value={obj.value}
                                    >
                                      {obj.label}
                                    </MenuItem>
                                  );
                                }
                              )}
                            </Select>
                          </FormControl>
                          <FormControl
                            variant="outlined"
                            style={{ width: "40%" }}
                          >
                            <InputLabel htmlFor="outlined-age-native-simple">
                              Success Action
                            </InputLabel>
                            <Select
                              value={
                                values.successAction &&
                                values.successAction.value
                                  ? values.successAction.value
                                  : ""
                              }
                              onChange={(event: any) => {
                                if (
                                  event &&
                                  event.target &&
                                  event.target.value
                                ) {
                                  let filtered = POPUP_TRIGGERS_ACTIONS.filter(
                                    (x: any) => {
                                      return x.value === event.target.value;
                                    }
                                  );
                                  setFieldValue("successAction", filtered[0]);
                                }
                              }}
                              label="Success Action"
                              inputProps={{
                                name: "successAction",
                                id: "outlined-age-native-simple",
                              }}
                            >
                              {POPUP_TRIGGERS_ACTIONS.map(
                                (obj: any, index: any) => {
                                  return (
                                    <MenuItem
                                      key={`machin-item-${index}`}
                                      value={obj.value}
                                    >
                                      {obj.label}
                                    </MenuItem>
                                  );
                                }
                              )}
                            </Select>
                          </FormControl>
                        </div>
                        <TextField
                          id="outlined-multiline-static"
                          label="Popup Content"
                          multiline
                          rows={4}
                          onChange={(event) => {
                            if (event && event.target && event.target.value) {
                              setFieldValue("popupContent", event.target.value);
                            }
                          }}
                          onBlur={handleBlur}
                          value={values.popupContent}
                          variant="outlined"
                          style={{ marginTop: 20 }}
                        />
                      </Paper>
                      <Paper
                        style={{
                          display: "flex",
                          margin: 20,
                          padding: 20,
                          width: "100%",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography>{"Quick Picks"}</Typography>
                          <IconButton
                            edge="end"
                            aria-label="add"
                            onClick={() =>
                              this.setState({
                                openAddQuickPicksDialog: true,
                              })
                            }
                          >
                            <AddIcon />
                          </IconButton>
                        </div>
                        <Divider />
                        <List style={{ width: "100%" }}>
                          {this.state.quickPicks.map(
                            (quickItem: any, index: any) => (
                              <ListItem
                                key={`quick-item-${quickItem.inspectionName}`}
                              >
                                <ListItemText
                                  primary={quickItem.inspectionName}
                                  secondary={`${convertTextToTitleCase(
                                    quickItem.inspectionType
                                  )} - ${convertTextToTitleCase(
                                    quickItem.inspectionCategory
                                  )}`}
                                />
                                <ListItemSecondaryAction>
                                  <IconButton
                                    edge="end"
                                    aria-label=""
                                    onClick={() => {
                                      this.setState({
                                        deletingIndex: index,
                                        confirmDelete: true,
                                      });
                                    }}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </ListItemSecondaryAction>
                              </ListItem>
                            )
                          )}
                        </List>
                      </Paper>
                    </div>

                    <DialogActions>
                      <Button
                        onClick={() => {
                          handleReset();
                          handleClose();
                        }}
                      >
                        {"CANCEL"}
                      </Button>
                      <Button
                        onClick={() => {
                          values.image = this.state.selectedImageItem;
                          values.quickPicks = this.state.quickPicks;
                          this.setState({
                            selectedImageItem: {
                              base64: "",
                              item: { filename: "", _id: "" },
                            },
                          });
                          handleOnSubmit(values);
                          handleReset();
                        }}
                        // disabled={validateIPaddress(values.api) ? false : true}
                      >
                        {"SAVE"}
                      </Button>
                    </DialogActions>
                  </div>
                </Form>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
        {this.renderImagesDialog()}
        {this.renderAddQuickPickDialog()}
        {this.renderConfirmDialog()}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(AddConfigurationDialog);
